import {PriceWatchDetailedToggle} from './PriceWatchDetailedToggle'

export {PriceWatchDetailedToggle}
